import type { TeamDTO } from "@nlc/shared-types";
import type { UseQueryResult } from "@tanstack/react-query";

import { useQuery } from "@tanstack/react-query";

import { teamsKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

async function getTeam(id: string): Promise<TeamDTO> {
  return apiClient.url(`/teams/${id}`).get().json();
}

export function useGetTeam(id: string): UseQueryResult<TeamDTO, Error> {
  return useQuery({
    enabled: !!id,
    queryFn: () => getTeam(id),
    queryKey: teamsKeys.detail(id),
  });
}
